import ResultsFormatterBase from "../../formatters/ResultsFormatterBase.js";
import { 
    ResultData, ResultType, PitchData, PitchReprocessed,
} from "../../enums/index.js";

class PitchSpinTiltFormatter extends ResultsFormatterBase{
    constructor() {
        super();
        this.separator = ':';
    }

    format(results) {
        for (let i = 0; i < results.length; i++){
            let result = results[i];

            if (!result || !result.hasOwnProperty(ResultData.Data.key) || !result[ResultData.Data.key]){
                continue;
            }

            if (result[ResultData.Type.key] !== ResultType.Pitch.key){
                continue;
            }

            if (!result[ResultData.Data.key].hasOwnProperty(PitchData.MlbSpinTiltHours.key) ||
                !result[ResultData.Data.key].hasOwnProperty(PitchData.MlbSpinTiltMinutes.key)){
                continue;
            }

            if (typeof(result[ResultData.Data.key][PitchData.MlbSpinTiltHours.key]) !== 'number'){
                continue;
            }

            if (typeof(result[ResultData.Data.key][PitchData.MlbSpinTiltMinutes.key]) !== 'number'){
                continue;
            }
            
            try {
                const hours = Math.abs(result[ResultData.Data.key][PitchData.MlbSpinTiltHours.key]);
                const minutes = Math.abs(result[ResultData.Data.key][PitchData.MlbSpinTiltMinutes.key]);

                if (hours > 12){
                    continue;
                }
                if (minutes > 60){
                    continue;
                }

                let hoursString = hours.toString();
                if (hoursString.length == 1){
                    hoursString = `0${hoursString}`;
                }

                let minutesString = minutes.toString();
                if (minutesString.length == 1){
                    minutesString = `0${minutesString}`;
                }
                
                const pitchSpinTilt = `${hoursString}${this.separator}${minutesString}`;
                result[ResultData.Data.key][PitchReprocessed.PitchSpinTiltR.key] = pitchSpinTilt;
            } catch (error) {
                // TODO - log
                continue;
            }
        }

        return results;
    }
};

export default PitchSpinTiltFormatter;